import './js/digital-content.js';;
import './css/^digital-content.scss';;

